import aes256 from 'aes256'


const ENCRYPT_KEY = process.env.STORAGE_ENCRYPT_KEY
const PREFIX =  'pt'


export const setItem = (key, value, { session = false } = {}) => {
  const storage = session ? sessionStorage : localStorage
  if(value === undefined){
    removeItem(key, session);
  }else{
    storage.setItem(`${PREFIX}-${key}`, aes256.encrypt(ENCRYPT_KEY, JSON.stringify(value)))
  }
}

export const getItem = (key, validationFunc) => {
  let value = localStorage.getItem(`${PREFIX}-${key}`)

  if (!value) value = sessionStorage.getItem(`${PREFIX}-${key}`)

  const jsonValue = value ? JSON.parse(aes256.decrypt(ENCRYPT_KEY, value)) : null
  if (jsonValue && validationFunc) {
    return validationFunc(jsonValue) ? jsonValue : null
  }
  return jsonValue
}

export const removeItem = (key, { session = null } = {}) => {
  if (session != null){
    const storage = session ? sessionStorage : localStorage
    storage.removeItem(`${PREFIX}-${key}`)
  } else {
    sessionStorage.removeItem(`${PREFIX}-${key}`)  
    localStorage.removeItem(`${PREFIX}-${key}`)
  }
}

export const clearStore = () => {
  sessionStorage.clear()

  localStorage.clear()
}



// WEBPACK FOOTER //
// ./src/services/storage.js